export interface RedpackRewardHint {
  id: number;
  amount: string;
  currencyType?: string;
  left: number;
  bottom: number;
  text: string;
}

export type RedpackRewardAmountConverter = (
  rewardcnt: number,
  currencyType?: string
) => number | string;

export interface CreateRedpackRewardHintParams {
  id: number;
  rewardcnt?: number | string | null;
  currencyType?: string;
  left: number;
  bottom: number;
  convertRewardAmount: RedpackRewardAmountConverter;
}

export const createRedpackRewardHint = ({
  id,
  rewardcnt,
  currencyType,
  left,
  bottom,
  convertRewardAmount,
}: CreateRedpackRewardHintParams): RedpackRewardHint | null => {
  const rawReward = Number(rewardcnt);

  if (!Number.isFinite(rawReward) || rawReward <= 0) {
    return null;
  }

  const convertedAmount = convertRewardAmount(rawReward, currencyType);
  const amountNumber = Number(convertedAmount);
  const amount = Number.isFinite(amountNumber)
    ? amountNumber.toFixed(2)
    : `${convertedAmount}`;

  return {
    id,
    amount,
    currencyType,
    left,
    bottom,
    text: `+${amount}`,
  };
};
